import React, { Component } from "react";
import styles from "../../../styles";
import {Div, Textarea} from "glamorous";

class LabelInput extends Component {
  componentDidMount() {
    this.forceUpdate();
  }

  render() {
    const { message, ratio } = this.props;

    let  textAreaHeight;
    if (this.refs.textValue) {
      textAreaHeight = this.refs.textValue.clientHeight;
    }

    return (
      <div>
        <Div css={styles.text.overlay} />
        <Div
          overflow="hidden"
          position="absolute"
          top="0"
          left="0"
          height="100%"
          width="100%"
        >
          <Textarea
            innerRef={el => {
              if (el && !this.textarea) {
                this.textarea = el;
                el.maxLength = 140;
                el.spellcheck = false;
                el.focus();
              }
            }}
            value={message.value}
            css={{
              ...styles.text.textarea,
              fontFamily: message.fontFamily,
              fontSize: message.fontSize * ratio,
              color: message.colour,
              zIndex: 999,
              height: `${textAreaHeight}px`,
              minHeight: message.fontSize * ratio,
              transform: `translate(-50% , -50%) translate(${message.x * ratio}px, ${message.y * ratio}px)`
            }}
            onChange={evt => this.props.updateTextValue(evt.currentTarget.value)}
            onKeyPress={evt => {
              if (evt.key === "Enter") {
                evt.preventDefault();
                this.textarea.blur();
              }
            }}
            onBlur={() => this.props.onComplete()}
          />

          <span
            ref="textValue"
            style={{
              ...styles.text.textValue,
              fontFamily: message.fontFamily,
              fontSize: `${message.fontSize * ratio}px`,
              visibility: "hidden"
            }}
          >
            {message.value}
          </span>
        </Div>
      </div>
    )
  }
};

export default LabelInput;



// WEBPACK FOOTER //
// ./src/components/areas/EditorText/LabelInput.js